import { FC } from 'react';
import { Service } from '#advertDetail/components/service-list';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import modelDetailParameterListCss from '../../assets/model-detail/model-detail-parameter-list.module.scss';

const ServiceList: FC = () => {
  const {
    advert: {
      serviceDataList,
    },
  } = useAdvertDetailContext();

  if (serviceDataList.length === 0) {
    return null;
  }

  const serviceElementList = serviceDataList.map((serviceData) => (
    <Service key={serviceData.id} serviceData={serviceData} />
  ));

  return (
    <div className={modelDetailParameterListCss.modelDetailParameterList}>
      {serviceElementList}
    </div>
  );
};

export { ServiceList };
